import React, {useMemo} from 'react';
import SidebarNavElements from './SidebarNavElements';
import s from './ProSideBar.module.css';
import {useGetBannerImagesQuery} from '../../redux/newsApi';
import {BannerImagesType} from '../../types/TypesNews';
import MediaBannerCarousel from './MediaBannerCarousel';

const ProSideBar = () => {
	const {data: bannersResp} = useGetBannerImagesQuery('main');

	const bannerImages: BannerImagesType[] = useMemo(
		() => bannersResp?.images ?? [],
		[bannersResp?.images],
	);
	return (
		<aside className={s.pageSide}>
			<SidebarNavElements />
			<div data-da=".page__content,850.98,1" className={s.pageBody}>
				{/* <div className={s.pageColumn}>
                    <div className={s.bonusSide}>
                        <div className={s.bonusSideLabel}>{apiData.text_your_bonus}</div>
                        <div className={s.bonusSidePrice}>150<span> </span></div>
                        <div className={s.bonusSideBg}>
                            <img src={side} alt="action"/></div>
                    </div>
                </div> */}
				<div className={s.pageColumn}>
					<div className={s.actionSide}>
						<MediaBannerCarousel banners={bannerImages} height={300} />
					</div>
				</div>
			</div>
		</aside>
	);
};

export default ProSideBar;
